const tools = {
  getIndex: (map, key, defaultValue) => {
    let posMap = key.split('.')
    let value = map
    while (posMap.length > 0) {
      let pos = posMap.shift()
      if (!(pos in value)) {
        return defaultValue
      }
      value = value[pos]
    }
    return value
  }
}

export default tools



// WEBPACK FOOTER //
// ./src/utils/base.js